import React, { Component } from 'react';
import classNames from 'classnames';
import { observer, inject } from 'mobx-react';

@inject("featuresListStore") @observer 
export default class FeaturesList extends Component {
  constructor(props){
    super(props)
  }
  render() {
    let { setLayout, resetFeatures } = this.props.featuresListStore;
    let buttonClass = classNames(
      'billy-features-list__button',
      'billy-button',
      'billy-box'
    )
    return (
      <div className="billy-features-list__actions">
        <button className={`${buttonClass} fi-billy fi-billy-refresh`} 
                onClick={ () => resetFeatures() } 
                aria-label="אפס פיצ׳רים">
        </button>
        <button className={`${buttonClass} fi-billy fi-billy-list`} 
                onClick={ () => setLayout('') } 
                aria-label="הצג כרשימה">
        </button>
        <button className={`${buttonClass} fi-billy fi-billy-grid`} 
                onClick={ () => setLayout('GRID') } 
                aria-label="הצג כתבנית">
        </button>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ActionsBar/index.js